import { gqlClient } from '../../components/AppProvider';
import { AccountOrder, CompanyVerificationStatus } from '../../gql-types.generated';
import { queryAllTenantAccounts } from '../../gql/QueryAllTenantAccounts';
import { AppThunk } from '../../store';
import { decrementRequestsInFlight, incrementRequestsInFlight } from '../app/AppSlice';
import { fetchAllTenantsStart, fetchError, fetchAllTenantsSuccess } from './AllTenantsSlice';

export const fetchAllTenants =
  (orderBy?: AccountOrder, after?: string, queryString?: string, status?: CompanyVerificationStatus[]): AppThunk =>
  async dispatch => {
    dispatch(incrementRequestsInFlight());
    if (!after) {
      dispatch(fetchAllTenantsStart());
    }

    try {
      const result = await queryAllTenantAccounts(gqlClient, {
        first: 25,
        after,
        orderBy,
        queryString,
        status,
      });

      if (!result) {
        dispatch(decrementRequestsInFlight());
        return;
      }

      dispatch(fetchAllTenantsSuccess(result));
      dispatch(decrementRequestsInFlight());
    } catch (e) {
      dispatch(fetchError(e as Error));
      dispatch(decrementRequestsInFlight());
    }
  };
